// Diego, 13-oct (ADENDA, pedido 8): "dale al que esté haciendo la cotización una recomendación de en qué rango anda la
// competencia en ese tamaño de sistema con esa tarifa". Datos de SunWise Analytics (Sonora, 2026), medidos el 13-oct:
// datos/competencia-sonora-2026.json. Es una REFERENCIA para el vendedor: no cambia ningún precio ni va en el PDF.
import DATOS from '../datos/competencia-sonora-2026.json' with { type: 'json' };
import type { Tarifa } from './basicos.ts';

export interface RangoCompetencia {
  /** USD por watt (sin IVA) de las propuestas de la competencia: mínimo y máximo por trimestre, y el promedio. */
  min: number;
  prom: number;
  max: number;
  retorno_min: number;
  retorno_max: number;
  /** «0–5 kWp», «100–250 kWp»… */
  rango: string;
  /** «GDMTH», «casas (tarifa 1)» o «todas las tarifas» cuando esa tarifa casi no tiene propuestas en ese tamaño. */
  grupo: string;
  medido: string;
}

type Celda = { min: number; prom: number; max: number; retorno_min: number; retorno_max: number };
type Grupo = { etiqueta: string } & Partial<Record<string, Celda>>;
const GRUPOS = DATOS.grupos as unknown as Record<string, Grupo>;

function grupoDe(tarifa: Tarifa): string {
  if (tarifa === 'PDBT' || tarifa === 'GDMTO' || tarifa === 'GDMTH') return tarifa;
  // DAC y GDBT casi no tienen propuestas en Sonora 2026: DAC usa las casas de tarifa 1 y GDBT el promedio de Sonora
  if (tarifa === 'GDBT') return 'sonora';
  return 'casa';
}

/** El rango de la competencia en Sonora para ese tamaño y tarifa; si esa tarifa no tiene datos en ese tamaño, el de todas las
 *  tarifas de Sonora. null si no hay tamaño. */
export function rangoCompetencia(tarifa: Tarifa, kwp: number): RangoCompetencia | null {
  if (!Number.isFinite(kwp) || kwp <= 0) return null;
  const r = DATOS.rangos_kwp.find((x) => kwp > x.desde && (x.hasta === null || kwp <= x.hasta)) ?? DATOS.rangos_kwp[0]!;
  const propio = GRUPOS[grupoDe(tarifa)];
  const celda = propio?.[r.id] ?? GRUPOS.sonora![r.id];
  if (!celda) return null;
  const grupo = propio?.[r.id] ? propio.etiqueta : GRUPOS.sonora!.etiqueta;
  return { ...celda, rango: r.etiqueta, grupo, medido: DATOS.medido };
}
